import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { Business } from '../models/business.model';
import { hasTag, loadTags } from '../../util/tag-utils';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { MatDialog, MatDialogConfig, MatSnackBar } from '@angular/material';
import { EditTagsComponent } from '../../shared/edit-tags/edit-tags.component';
import { EditDescComponent } from '../edit-desc/edit-desc.component';
import { EditClubDetailsComponent } from '../edit-club-details/edit-club-details.component';
import { BusinessManagerService } from '../../shared/user/business-manager.service';
var DialogType;
(function (DialogType) {
    DialogType[DialogType["features"] = 0] = "features";
    DialogType[DialogType["description"] = 1] = "description";
    DialogType[DialogType["details"] = 2] = "details";
})(DialogType || (DialogType = {}));
var FlyingClubComponent = /** @class */ (function () {
    function FlyingClubComponent(_toggleService, _editFeaturesDialog, _editDescDialog, snackBar, _businessManagerService) {
        this._toggleService = _toggleService;
        this._editFeaturesDialog = _editFeaturesDialog;
        this._editDescDialog = _editDescDialog;
        this.snackBar = snackBar;
        this._businessManagerService = _businessManagerService;
        this.facilitiesTags = [];
        this.typesOfFlyingTags = [];
        this.hasTag = hasTag;
        this.editModeSet = false;
        this.isAmbassador = false;
    }
    FlyingClubComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this._loadAllTags();
                        this._toggleService.toggleEmitter.subscribe(function (isOn) {
                            _this.editModeSet = isOn;
                        });
                        if (!(hasTag(this.business.tags, 'Flying Club') && this.business.flyingClub)) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this._businessManagerService.isAmbassador()];
                    case 1:
                        _a.isAmbassador = _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(FlyingClubComponent.prototype, "hasContent", {
        get: function () {
            return this.business && !!this.business.description || this.hasClubFeatureData || this.hasClubDetailData;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FlyingClubComponent.prototype, "hasClubFeatureData", {
        get: function () {
            return (this.facilitiesTags.length > 0 || this.typesOfFlyingTags.length > 0);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FlyingClubComponent.prototype, "hasClubDetailData", {
        get: function () {
            if (!this.business) {
                return false;
            }
            if (hasTag(this.business.tags, 'Flying Club') && this.business.flyingClub) {
                if (this.business.flyingClub.clubAircraft || this.business.flyingClub.clubMembers) {
                    return true;
                }
            }
            return (hasTag(this.business.tags, 'Flying Club::AOPA::AOPA Network')
                || hasTag(this.business.tags, 'Flying Club::Membership::Open')
                || hasTag(this.business.tags, 'Flying Club::Equity Club')
                || hasTag(this.business.tags, 'Flying Club::Non-Equity Club')
                || hasTag(this.business.tags, 'Flying Club::Hybrid-Equity Club'));
        },
        enumerable: true,
        configurable: true
    });
    FlyingClubComponent.prototype._loadAllTags = function () {
        this.facilitiesTags = loadTags(this.business.tags, 'Flying Club::Benefits::', '', '');
        this.typesOfFlyingTags = loadTags(this.business.tags, 'Flying Club::Flying::', '', '');
    };
    FlyingClubComponent.prototype._openModal = function (component, data) {
        if (data === void 0) { data = {}; }
        var dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.data = data;
        dialogConfig.width = '100%';
        switch (component) {
            case DialogType.features: {
                return this._editFeaturesDialog.open(EditTagsComponent, dialogConfig);
            }
            case DialogType.description: {
                return this._editDescDialog.open(EditDescComponent, dialogConfig);
            }
            case DialogType.details: {
                var MODAL_WIDTH = Math.floor(100 + ((550 - window.innerWidth) / (10 * (window.innerWidth / 1000))));
                dialogConfig.width = MODAL_WIDTH <= 100 ? MODAL_WIDTH + '%' : '100%';
                return this._editDescDialog.open(EditClubDetailsComponent, dialogConfig);
            }
        }
    };
    /**
     * listens for dialog close event. Opens snackbar if necessary
     * @param {MatDialogRef<any>} dialogRef
     * @private
     */
    FlyingClubComponent.prototype._handleModalClose = function (dialogRef) {
        var _this = this;
        var ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
        dialogRef.afterClosed().subscribe(function (success) {
            if (success === null) {
                return;
            }
            if (success) {
                _this.snackBar.open('Club Description', 'Updated', {
                    duration: 3000
                });
            }
            else {
                _this.snackBar.open(ERROR_MSG, 'Error', {
                    duration: 6000
                });
            }
        });
    };
    /**
     * Opens modal for editing business overview section, displays snackbar if serverAPI was successfully updated.
     */
    FlyingClubComponent.prototype.openEditFeaturesDialog = function (group, title) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var DATA, DIALOG_REF, SUCCESS;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        DATA = {
                            business: this.business,
                            tagsGroup: group,
                            title: title
                        };
                        DIALOG_REF = this._openModal(DialogType.features, DATA);
                        return [4 /*yield*/, DIALOG_REF.afterClosed().toPromise()];
                    case 1:
                        SUCCESS = _a.sent();
                        if (SUCCESS) {
                            this._loadAllTags();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    FlyingClubComponent.prototype.openEditDescDialog = function () {
        var DATA = { business: this.business };
        var DIALOG_REF = this._openModal(DialogType.description, DATA);
        this._handleModalClose(DIALOG_REF);
    };
    FlyingClubComponent.prototype.openEditDetailsDialog = function () {
        var DATA = { business: this.business };
        var DIALOG_REF = this._openModal(DialogType.details, DATA);
        this._handleModalClose(DIALOG_REF);
    };
    return FlyingClubComponent;
}());
export { FlyingClubComponent };
